import './AnchoredOverlay-73c1b2d1.css';

var classes = {"ResponsiveCloseButtonContainer":"prc-AnchoredOverlay-ResponsiveCloseButtonContainer-NL5kN","ResponsiveCloseButton":"prc-AnchoredOverlay-ResponsiveCloseButton-Rr-c2"};

export { classes as default };
